import { isNil } from 'lodash';
import { FC, ReactNode } from 'react';
import styles from './AuthFormHeader.module.scss';
import clsx from 'clsx';

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  className?: string;
}

export const AuthFormHeader: FC<Props> = ({ title, subtitle, description, className }) => {
  return (
    <section className={clsx(styles.root, className)}>
      <header className={styles.header}>
        {!isNil(title) && <h1 className={clsx(styles.title, 'auth-header')}>{title}</h1>}
        {!isNil(subtitle) && <div className={clsx(styles.subtitle, 'auth-subtitle')}>{subtitle}</div>}
      </header>
      {!isNil(description) && <div className={clsx(styles.description, 'auth-description')}>{description}</div>}
    </section>
  );
};
